import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

export interface CriterioComportamientoSv {
  id?: number;
  criterio: string;
  descripcion?: string | null;
  peso?: number | null;
  estado?: number;
}

@Injectable({ providedIn: "root" })
export class CriteriosComportamientoSvService {
  private readonly baseUrl = `${environment.apiUrl}/api/criterios_comportamiento_sv_catalogo`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<any> {
    return this.http.get(this.baseUrl);
  }

  getById(id: number): Observable<any> {
    return this.http.get(`${this.baseUrl}/${id}`);
  }

  create(payload: CriterioComportamientoSv): Observable<any> {
    return this.http.post(this.baseUrl, payload);
  }

  update(id: number, payload: Partial<CriterioComportamientoSv>): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}`, payload);
  }

  activar(id: number): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}/activar`, {});
  }

  inactivar(id: number): Observable<any> {
    return this.http.put(`${this.baseUrl}/${id}/inactivar`, {});
  }
}